import SockJS from 'sockjs-client'
import Stomp from 'webstomp-client'

var stompClient = null

export default {
  connect(callback, retailId) {
    var socket = new SockJS('/api/websocket')
    stompClient = Stomp.over(socket)
    stompClient.connect({}, function (frame) {
      // eslint-disable-next-line no-console
      console.log('Connected: ' + frame)
      stompClient.subscribe(
        '/notifications/update-ticket' + '/' + retailId,
        callback,
      )
    })
  },

  disconnect() {
    if (stompClient !== null) {
      stompClient.disconnect()
    }
    // eslint-disable-next-line no-console
    console.log('Disconnected')
  },
}
